/**
 * Utility functions for string manipulation
 */

/**
 * Generates a random alphanumeric string
 * @param length The length of the random string to generate
 * @returns A random string of the specified length
 */
export function generateRandomString(length: number = 15): string {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from(
    { length },
    () => chars[Math.floor(Math.random() * chars.length)]
  ).join('');
}

/**
 * Removes specified query parameters from a URL
 * @param url The URL to clean
 * @param params Array of parameter names to remove (defaults to ['code', 'state'])
 * @returns The cleaned URL without the specified parameters
 */
export function removeQueryParams(
  url: string,
  params: string[] = ['code', 'state']
): string {
  const paramPattern = params.join('|');
  return (
    url
      // eslint-disable-next-line security/detect-non-literal-regexp -- pattern built from internal param names
      .replace(new RegExp(`[?&](${paramPattern})=[^&]+`, 'g'), '')
      .replace(/\?&?$/, '')
  );
}
